export default "__VITE_ASSET__D4JrVu6N__"